import { useRef } from 'react';
import { Typography, Stack } from '@optimus-web/core';
import ProfileAvatar from '../ProfileAvatar';
import ProfileName from '../ProfileName';
import ThreadSubject from '../ThreadSubject';
import { ThreadItemProps } from './types';
import { ThreadAuthor, ThreadContainer, ThreadSubject as ThreadSubjectWrapper } from './style';

const ThreadsPanelItemComponent = ({ thread, onThreadSelected, isActive }: ThreadItemProps) => {
    const containerRef = useRef<HTMLButtonElement>(null);
    const handleItemClicked = () => {
        onThreadSelected(thread);
        const { current: container } = containerRef;
        if (container) {
            container.blur();
        }
    };

    const { creatorProfileId, id, isRead, subject, updated } = thread;

    return (
        <ThreadContainer
            isActive={isActive}
            onClick={handleItemClicked}
            leftAvatar={
                <ProfileAvatar
                    threadId={id}
                    profileId={creatorProfileId}
                    notification={!isRead}
                    size="medium"
                    useBigEnterpriseImage
                />
            }
            primaryText={
                <Stack spacing="100" distribution="stretch" itemAlignment="center">
                    <ThreadAuthor unread={!isRead}>
                        <ProfileName threadId={id} profileId={creatorProfileId} />
                    </ThreadAuthor>
                    <Typography
                        textStyle="bodySmallStrong"
                        variant="secondary"
                        align="right"
                        whiteSpace="nowrap"
                        as="div"
                    >
                        {updated}
                    </Typography>
                </Stack>
            }
            secondaryText={
                <ThreadSubjectWrapper unread={!isRead}>
                    <ThreadSubject subject={subject} profileId={creatorProfileId} />
                </ThreadSubjectWrapper>
            }
        />
    );
};

export default ThreadsPanelItemComponent;
